import Brightness4Icon from '@mui/icons-material/Brightness4';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { colorModeLabelKeys, useColorMode } from '../theme/colorMode';

export function ColorModeToggle() {
  const { mode, cycleMode } = useColorMode();
  const { t } = useTranslation();

  const icon =
    mode === 'light' ? (
      <LightModeIcon fontSize="small" />
    ) : mode === 'dark' ? (
      <DarkModeIcon fontSize="small" />
    ) : (
      <Brightness4Icon fontSize="small" />
    );

  const label = t(colorModeLabelKeys[mode]);

  return (
    <Tooltip title={label}>
      <IconButton onClick={cycleMode} aria-label={label} color="inherit">
        {icon}
      </IconButton>
    </Tooltip>
  );
}
